import { useEffect, useState } from "react"
import { AccountEditor } from "../../../../../editor/AccountEditor"
import { AdquisitionItemSelector } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectModalityNewSer } from "../../../../../contract/select/SelectModalityNewSer";
import { ContractTypeEditor } from "../../../../../contract/select/ContractTypeEditor";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { _AdquisitionContract, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { AdquisitionItemBudgetID } from "../../../../../contract/AdquisitionItemBudgetID";

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
    onlyInfo?: boolean
}

export const SO004 = ({ configProcedure, onlyInfo }: Props) => {

    const { instance } = useDataBean(_AdquisitionContract)

    const [props, setProps] = useState<any>({});
    const [bean, setBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData]);

    useEffect(() => {
        setBean({
            IDAccount: props.IDAccount,
            IDAdquisitionItem: props.IDAdquisitionItem,
            isLote: false,
            ContractValue: props.TotalValue,
            AdquisitionContractDate: props.AdquisitionContractDate,
            EndContractDate: props.EndContractDate,
            IDEmployee: _single.getAccountID(),
            IDAdquisitionContract: props.IDAdquisitionContract,
            Code: props.Code,
            InternalCode: props.InternalCode,
            IDHiringModality: props.IDHiringModality,
            IDContractType: props.IDContractType,
            State: 1
        })
    }, [props])

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            if (onlyInfo) {
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(`Se agrego datos basicos de la minuta`)
                }

                if (configProcedure?._pushProps) {
                    configProcedure?._pushProps({ ...bean });
                }

                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(bean);
                }
            }
            else {
                crearContrato();
            }
        }
    }

    const crearContrato = () => {
        console.log(bean)
        instance.registerAdquisitionContractByItems(_single.getAccountID(), bean).then(
            (resp: any) => {
                onExportMap(resp)
            }
        ).catch(err => { toast.error(err); })
    }

    const onExportMap = (obj?: any) => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(`Se creo el contrato con ID ${obj.IDAdquisitionContract}`)
        }

        if (configProcedure?._pushProps && obj) {
            configProcedure?._pushProps({ ...obj });
        } else {
            configProcedure?._pushProps({ ...bean });
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "AdquisitionContractDate", "IDAccount",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-12">
                        <label className={`${missingFields.includes('IDAdquisitionItem') ? 'has-error' : ''}`}>Necesidad</label>
                    </div>
                    <div className="col-12">
                        <AdquisitionItemSelector ConfigProps={{ filterState: 40, disable: props.IDAdquisitionItem ? true : false }} idAdquisitionItem={bean.IDAdquisitionItem} onChage={(item: any) => {
                            setBean({ ...bean, "IDAdquisitionItem": item.IDAdquisitionItem, ContractValue: item.TotalValue });
                        }} />
                    </div>
                    {bean.IDAdquisitionItem &&
                        <AdquisitionItemBudgetID adquisitionItem={bean} iDBudgetIDType={null} CanModify={40} />
                    }
                </div>
                <hr />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('AdquisitionContractDate') ? 'has-error' : ''}`}>Fecha Contrato</label>
                <InputDate label=" " name="AdquisitionContractDate" value={bean.AdquisitionContractDate} setDate={(e) => { setBean({ ...bean, "AdquisitionContractDate": e }) }} />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('AdquisitionContractDate') ? 'has-error' : ''}`}>Fecha Finalización del Contrato</label>
                <InputDate label=" " name="EndContractDate" value={bean.EndContractDate} setDate={(e) => { setBean({ ...bean, "EndContractDate": e }) }} />
            </div>
            <div className="col-md-6">
                <label>Código Interno Contrato</label>
                <input type="text" className="form-control" value={bean.InternalCode} onChange={(e) => { setBean({ ...bean, "InternalCode": e.target.value }) }} />
            </div>

            <div className="col-md-6">
                <label>Radicado Contrato</label>
                <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, "Code": e.target.value }) }} />
            </div>
            <div className="col-md-6">
                <label>Valor de Contrato:</label>
                <InputMoney _label=" " _value={bean.ContractValue} onChange={(e) => { setBean({ ...bean, "ContractValue": e }) }} />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Proveedor</label>
                <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
            </div>
            <div className="col-md-6">
                <SelectModalityNewSer disable={props.NotModifyHiringModality} label={'Modalidad'} idSelector={bean.IDHiringModality} onChange={(e) => { setBean({ ...bean, "IDHiringModality": e }) }} />
            </div>
            <div className="col-md-6">
                <ContractTypeEditor label={'Tipo Contrato'} idSelector={bean.IDContractType} onChange={(e) => { setBean({ ...bean, "IDContractType": e }) }} />
            </div>
            <div className="col-md-12">
                <BasicButton eventClick={validateData} icon="ri-save-line" children={`${onlyInfo ? "Enviar" : "Crear"}`} />
            </div>
        </div>
    )
}